import { GridOptions } from 'ag-grid-community';
import { Model } from '../../../models/model';

// @ts-ignore
export class AtlasGridOptions extends Model implements GridOptions {
  public static sortingRule = {
    type: { NUMERIC: 'numeric', STRING: 'string' }
  };
}
